/**
 * @file src/pages/company-onboarding-wizard/useCreateCompany.js
 * @description React Query mutation hook for company creation.
 *
 * Rules:
 *  - mutationFn calls api/company.api.js — never direct axios
 *  - No onSuccess / onError here — handled by useOnboardingActions
 *    so the caller controls navigation and error display
 *  - No console.log
 */
import { useMutation } from "@tanstack/react-query";
import { createCompany } from "api/company.api";

/**
 * Mutation hook for creating a new company.
 * Callers provide onSuccess and onError via mutate() options.
 *
 * Usage:
 *  const { mutate, isLoading } = useCreateCompany();
 *  mutate(formData, { onSuccess: () => {}, onError: (err) => {} });
 */
export const useCreateCompany = () => {
  return useMutation({
    mutationFn: (body) => createCompany(body),
  });
};
